export const RAKUTEN_POINTS = 15000
export const PAYPAY_POINTS_PCT = 2
